export function rewirteLog() {
  console.log = (function(log) {
    return process.env.NODE_ENV == "development" ? log : function() {};
  })(console.log);
}

// 转换UTC时间
export function formatUTC(datetime) {
  const date = new Date(datetime);
  return (
    date.getFullYear() +
    "-" +
    (date.getMonth() + 1) +
    "-" +
    (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
    " " +
    date.getHours() +
    ":" +
    date.getMinutes() +
    ":" +
    (date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds())
  );
}
